var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('form-wizard', {
    attrs: {
      "color": "#ff9801",
      "title": null,
      "subtitle": null,
      "finish-button-text": "Simpan",
      "back-button-text": "Sebelumnya",
      "next-button-text": "Selanjutnya"
    },
    on: {
      "on-complete": _vm.formSubmitted
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Daftar Barang"
    }
  }, [_c('validation-observer', {
    ref: "formBarang"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('h6', {
    staticClass: "mb-1"
  }, [_vm._v("Tambah Barang")]), _c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-checkbox', {
    on: {
      "change": _vm.onToggleDariPembelian
    },
    model: {
      value: _vm.dariPembelian,
      callback: function callback($$v) {
        _vm.dariPembelian = $$v;
      },
      expression: "dariPembelian"
    }
  }, [_vm._v(" Dari Pembelian ")])], 1), _vm.dariPembelian ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-1",
    attrs: {
      "label": "Pilih Kode Pembelian"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.pembelianOptions,
      "label": "text",
      "reduce": function reduce(option) {
        return option.value;
      },
      "placeholder": "Cari kode pembelian..."
    },
    on: {
      "input": _vm.onPembelianSelected
    },
    model: {
      value: _vm.selectedPembelianId,
      callback: function callback($$v) {
        _vm.selectedPembelianId = $$v;
      },
      expression: "selectedPembelianId"
    }
  })], 1)], 1) : _vm._e()], 1), _c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-1",
    attrs: {
      "label": "Pilih Barang"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "barang",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          attrs: {
            "reduce": function reduce(option) {
              return option.value;
            },
            "options": _vm.barangOptionsFiltered,
            "label": "text",
            "disabled": _vm.dariPembelian && !_vm.selectedPembelianId,
            "placeholder": "Cari barang..."
          },
          model: {
            value: _vm.formBarang.barang_id,
            callback: function callback($$v) {
              _vm.$set(_vm.formBarang, "barang_id", $$v);
            },
            expression: "formBarang.barang_id"
          }
        }), _vm.dariPembelian && !_vm.selectedPembelianId ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" Pilih kode pembelian terlebih dahulu ")]) : _vm._e(), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-1",
    attrs: {
      "label": "Jumlah"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nilai",
      "rules": "required|positive"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "type": "number",
            "state": errors.length > 0 ? false : null
          },
          on: {
            "input": _vm.recalcKonversi
          },
          model: {
            value: _vm.formBarang.nilai,
            callback: function callback($$v) {
              _vm.$set(_vm.formBarang, "nilai", $$v);
            },
            expression: "formBarang.nilai"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-1",
    attrs: {
      "label": "Satuan Konversi"
    }
  }, [_c('v-select', {
    attrs: {
      "reduce": function reduce(option) {
        return option.value;
      },
      "options": _vm.konversiOptions,
      "label": "text",
      "disabled": _vm.konversiOptions.length < 1,
      "placeholder": "pcs"
    },
    model: {
      value: _vm.formBarang.selectedKonversiId,
      callback: function callback($$v) {
        _vm.$set(_vm.formBarang, "selectedKonversiId", $$v);
      },
      expression: "formBarang.selectedKonversiId"
    }
  }), _vm.konversiOptions.length < 1 ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Default pcs ")]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-1",
    attrs: {
      "label": "Hasil Konversi"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.formBarang.jumlah,
      "type": "number",
      "readonly": "",
      "disabled": ""
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.satuanTerkecilLabel) + " ")])], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-1",
    attrs: {
      "label": "No Container"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Opsional"
    },
    model: {
      value: _vm.formBarang.no_container,
      callback: function callback($$v) {
        _vm.$set(_vm.formBarang, "no_container", $$v);
      },
      expression: "formBarang.no_container"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-1",
    attrs: {
      "label": "No Seal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Opsional"
    },
    model: {
      value: _vm.formBarang.no_seal,
      callback: function callback($$v) {
        _vm.$set(_vm.formBarang, "no_seal", $$v);
      },
      expression: "formBarang.no_seal"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addBarang($event);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Tambah ")], 1)], 1)], 1)], 1), _c('b-card', [_c('h6', {
    staticClass: "mb-1"
  }, [_vm._v("Barang Ditambahkan")]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "fields": _vm.tableFields,
      "items": _vm.selectedBarangs
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(row.index + 1))])];
      }
    }, {
      key: "cell(nama)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('div', [_vm._v(_vm._s(item.nama || "-"))]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" No Container: " + _vm._s(item.no_container || "-") + " ")]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" No Seal: " + _vm._s(item.no_seal || "-") + " ")]), item.dari_po || item.pembelian_rincian_id ? _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" Kode PO: " + _vm._s(item.dari_po || "-") + " ")]) : _vm._e()];
      }
    }, {
      key: "cell(qty_pembelian)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('span', [_vm._v(_vm._s(item.qty_pembelian != null ? item.qty_pembelian : "-"))]), item.qty_pembelian != null && item.jumlah != item.qty_pembelian ? _c('b-badge', {
          staticClass: "ml-50",
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v(" Berbeda ")]) : _vm._e()];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(row) {
        return [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Urungkan',
            expression: "'Urungkan'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.removeBarang(row);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "XIcon"
          }
        })], 1)];
      }
    }])
  }), _vm.selectedBarangs.length < 1 ? _c('p', {
    staticClass: "text-muted mb-0 text-center py-1"
  }, [_vm._v(" Belum ada barang. Tambahkan dari form di atas. ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }